import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { FaTimes } from 'react-icons/fa' // Import the close icon
import axios from 'axios'
import useAuth from '../hooks/useAuth'
import ProfileIcon from './ProfileIcon'

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation()
  const { logout, setUser } = useAuth()
  const [userInfo, setUserInfo] = useState({})
  const [loading, setLoading] = useState(true)

  const isActive = (path) => location.pathname === path

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/user/me`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('reekapToken')}`,
            },
          }
        )

        const { name, subscription } = response.data.data

        setUserInfo({
          name,
          plan: subscription.planId.name,
        })
        setUser(response.data.data)
        setLoading(false)
      } catch (error) {
        console.error('Error fetching user profile:', error)
        setLoading(false)
      }
    }

    fetchUserProfile()
  }, [setUser])

  if (loading) {
    return (
      <aside className='bg-[#233445] text-white w-64 h-screen flex items-center justify-center'>
        <div className='loading-spinner'></div>
      </aside>
    )
  }

  return (
    <aside
      className={`bg-[#233445] text-white w-64 h-screen flex flex-col fixed md:relative z-10 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } transition-transform duration-300 ease-in-out md:translate-x-0`}
    >
      {/* Close Button for Mobile */}
      <button
        onClick={toggleSidebar}
        className='md:hidden text-white p-4 self-end'
        aria-label='Close sidebar'
      >
        <FaTimes size={24} />
      </button>

      {/* Logo - links to the homepage */}
      <div className='p-6 mb-6 text-center'>
        <Link to='/'>
          <img
            src='/assets/images/reekap_logo.svg'
            alt='Reekap Logo'
            className='h-12 mx-auto'
          />
        </Link>
      </div>

      {/* Profile Section */}
      <div className='flex flex-col items-center px-6 mb-8'>
        <ProfileIcon name={userInfo.name || 'JD'} />
        <h2 className='text-lg font-bold text-white mt-4'>
          {userInfo.name || 'Loading...'}
        </h2>
        <p className='text-sm text-[rgba(255,255,255,0.60)]'>
          {userInfo.plan || 'Free Plan'}
        </p>
      </div>

      {/* Navigation Links */}
      <nav className='flex-grow'>
        <ul className='space-y-2 px-6'>
          <li>
            <Link
              to='/dashboard'
              className={`flex items-center p-3 rounded ${
                isActive('/dashboard') ? 'bg-[#38b6ff]' : 'hover:bg-[#2c4257]'
              }`}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='25'
                viewBox='0 0 24 25'
                fill='none'
              >
                <path
                  d='M13.5 9.44244V4.44244H20V9.44244H13.5ZM4 12.4424V4.44244H10.5V12.4424H4ZM13.5 20.4424V12.4424H20V20.4424H13.5ZM4 20.4424V15.4424H10.5V20.4424H4ZM5 11.4424H9.5V5.44244H5V11.4424ZM14.5 19.4424H19V13.4424H14.5V19.4424ZM14.5 8.44244H19V5.44244H14.5V8.44244ZM5 19.4424H9.5V16.4424H5V19.4424Z'
                  fill='white'
                />
              </svg>
              <span className='ml-3 text-white text-[16px] font-bold'>
                Dashboard
              </span>
            </Link>
          </li>
          {/* <li>
            <Link
              to="/notifications"
              className={`flex items-center p-3 rounded ${
                isActive('/notifications') ? 'bg-[#38b6ff]' : 'hover:bg-[#2c4257]'
              }`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <path d="M9.00001 21.4424C9.79601 22.0644 10.848 22.4424 12 22.4424C13.152 22.4424 14.204 22.0644 15 21.4424M2.53001 14.8364C2.31701 16.1894 3.26801 17.1284 4.43201 17.5964C8.89501 19.3914 15.105 19.3914 19.568 17.5964C20.732 17.1284 21.683 16.1894 21.47 14.8364C21.34 14.0044 20.693 13.3124 20.214 12.6364C19.587 11.7394 19.525 10.7624 19.524 9.72144C19.525 5.70244 16.157 2.44244 12 2.44244C7.843 2.44244 4.47501 5.70244 4.47501 9.72244C4.47501 10.7624 4.41301 11.7404 3.78501 12.6364C3.30701 13.3124 2.66101 14.0044 2.53001 14.8364Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              <span className="ml-3 text-white text-[16px] font-bold">Notification</span>
            </Link>
          </li> */}
          <li>
            <Link
              to='/plans'
              className={`flex items-center p-3 rounded ${
                isActive('/plans') ? 'bg-[#38b6ff]' : 'hover:bg-[#2c4257]'
              }`}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='25'
                viewBox='0 0 24 25'
                fill='none'
              >
                <g clipPath='url(#clip0_88_189)'>
                  <path
                    d='M14.316 9.54016C14.1775 9.1506 13.922 8.81337 13.5844 8.57462C13.2469 8.33588 12.8438 8.20728 12.4303 8.20644H10.8823C10.4407 8.20413 10.0139 8.36566 9.68444 8.65979C9.355 8.95392 9.14633 9.35977 9.09877 9.79884C9.05122 10.2379 9.16816 10.679 9.42699 11.0369C9.68582 11.3947 10.0681 11.6439 10.5 11.7362L12.8572 12.2504C13.3391 12.356 13.7651 12.6359 14.0533 13.0364C14.3414 13.4369 14.4714 13.9297 14.4183 14.4203C14.3651 14.9108 14.1326 15.3644 13.7653 15.6938C13.398 16.0233 12.922 16.2055 12.4286 16.2053H11.0966C10.2257 16.2053 9.48517 15.6499 9.21089 14.8733M11.7635 8.20644V6.20587M11.7635 18.2059V16.207M3.42517 23.5819V19.2962H7.71089'
                    stroke='white'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M22.9509 10.3922C23.406 12.8182 23.0427 15.3268 21.9179 17.524C20.7931 19.7212 18.9706 21.4828 16.7364 22.5323C14.5022 23.5817 11.9828 23.8596 9.57359 23.3223C7.16438 22.7849 5.00177 21.4629 3.42519 19.5636M1.04919 14.4927C0.594093 12.0667 0.957439 9.55813 2.0822 7.36088C3.20697 5.16364 5.02948 3.40206 7.26368 2.35263C9.49788 1.3032 12.0173 1.02533 14.4265 1.56263C16.8357 2.09994 18.9983 3.42199 20.5749 5.3213'
                    stroke='white'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M20.5749 1.30302V5.58873H16.2892'
                    stroke='white'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_88_189'>
                    <rect
                      width='24'
                      height='24'
                      fill='white'
                      transform='translate(0 0.442444)'
                    />
                  </clipPath>
                </defs>
              </svg>
              <span className='ml-3 text-white text-[16px] font-bold'>
                Plans
              </span>
            </Link>
          </li>
          <li>
            <Link
              to='/profile'
              className={`flex items-center p-3 rounded ${
                isActive('/profile') ? 'bg-[#38b6ff]' : 'hover:bg-[#2c4257]'
              }`}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='25'
                viewBox='0 0 24 25'
                fill='none'
              >
                <path
                  d='M4 18.4424C4 17.3816 4.42143 16.3642 5.17157 15.614C5.92172 14.8639 6.93913 14.4424 8 14.4424H16C17.0609 14.4424 18.0783 14.8639 18.8284 15.614C19.5786 16.3642 20 17.3816 20 18.4424C20 18.9729 19.7893 19.4816 19.4142 19.8567C19.0391 20.2317 18.5304 20.4424 18 20.4424H6C5.46957 20.4424 4.96086 20.2317 4.58579 19.8567C4.21071 19.4816 4 18.9729 4 18.4424Z'
                  stroke='white'
                  strokeLinejoin='round'
                />
                <path
                  d='M12 10.4424C13.6569 10.4424 15 9.0993 15 7.44244C15 5.78559 13.6569 4.44244 12 4.44244C10.3431 4.44244 9 5.78559 9 7.44244C9 9.0993 10.3431 10.4424 12 10.4424Z'
                  stroke='white'
                />
              </svg>
              <span className='ml-3 text-white text-[16px] font-bold'>
                Profile
              </span>
            </Link>
          </li>
          <li>
            <a
              href='https://docs.google.com/forms/d/e/1FAIpQLSek71t9jRVnOrTlZGrdNz_5-orRXvhVvrU5f6_HIL012-43Vw/viewform?usp=sf_link'
              target='_blank' // Opens the form in a new tab
              rel='noopener noreferrer' // Adds security for opening links in a new tab
              className={`flex items-center p-3 rounded ${
                isActive('/support') ? 'bg-[#38b6ff]' : 'hover:bg-[#2c4257]'
              }`}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='25'
                viewBox='0 0 24 25'
                fill='none'
              >
                <path
                  d='M12 16.7282C11.6644 16.7283 11.3362 16.6299 11.056 16.4453C10.7758 16.2606 10.556 15.9977 10.4237 15.6893C10.1472 15.624 9.87493 15.5415 9.60859 15.4424L9.59402 15.4373C8.81194 15.1437 8.09009 14.7098 7.46402 14.1567C6.62521 13.4168 5.98015 12.4829 5.58508 11.4364C5.19001 10.3899 5.05694 9.26273 5.19746 8.15305C5.33797 7.04337 5.74781 5.98491 6.39125 5.06996C7.03468 4.15501 7.89217 3.41135 8.88895 2.90383C9.88572 2.3963 10.9915 2.14032 12.1099 2.15821C13.2283 2.1761 14.3254 2.4673 15.3054 3.00644C16.2854 3.54557 17.1187 4.31627 17.7326 5.25133C18.3464 6.18638 18.7222 7.25741 18.8272 8.37102C18.8606 8.72502 18.57 9.01387 18.2143 9.01387C17.8594 9.01387 17.5757 8.72502 17.5346 8.37187C17.4213 7.39755 17.0527 6.47041 16.4662 5.68418C15.8797 4.89795 15.0961 4.28049 14.1944 3.89423C13.2928 3.50796 12.3052 3.36658 11.3314 3.48438C10.3576 3.60218 9.43215 3.97498 8.64863 4.56509C7.86511 5.1552 7.25126 5.94171 6.86915 6.84512C6.48704 7.74852 6.35021 8.73679 6.47249 9.71003C6.59477 10.6833 6.97182 11.607 7.56554 12.3878C8.15925 13.1686 8.94858 13.7788 9.85373 14.1567L9.88802 14.1713C10.0594 14.2416 10.2354 14.3036 10.416 14.3573C10.5811 13.955 10.893 13.6305 11.2884 13.4494C11.6838 13.2684 12.1333 13.2445 12.5457 13.3824C12.9581 13.5204 13.3027 13.8099 13.5097 14.1924C13.7166 14.5749 13.7705 15.0217 13.6603 15.4424C13.5653 15.8105 13.3506 16.1365 13.0501 16.3693C12.7495 16.602 12.3801 16.7283 12 16.7282ZM6.00002 15.4424H7.00202C6.5228 15.0689 6.08642 14.6435 5.70087 14.1739C5.07491 14.2472 4.49768 14.5478 4.07878 15.0187C3.65989 15.4896 3.42851 16.0979 3.42859 16.7282V17.341C3.42859 20.5279 7.03716 22.7282 12 22.7282C16.9629 22.7282 20.5714 20.407 20.5714 17.341V16.7282C20.5714 16.0462 20.3005 15.3921 19.8183 14.9099C19.3361 14.4276 18.682 14.1567 18 14.1567H14.8757C15 14.5734 15.0321 15.0121 14.97 15.4424H18L18.1243 15.4484C18.4423 15.4793 18.7374 15.6275 18.9521 15.8641C19.1668 16.1006 19.2857 16.4087 19.2857 16.7282V17.341L19.2814 17.479C19.1614 19.639 16.2223 21.4424 12 21.4424C7.61916 21.4424 4.7143 19.633 4.7143 17.341V16.7282L4.7203 16.6039C4.75119 16.2859 4.89935 15.9908 5.13593 15.7761C5.3725 15.5614 5.68054 15.4424 6.00002 15.4424ZM16.2857 9.01387C16.2859 9.79026 16.0751 10.5521 15.6759 11.218C15.2768 11.8839 14.7042 12.4289 14.0194 12.7947C13.467 12.2921 12.7469 12.0137 12 12.0139C12.394 12.0139 12.7841 11.9363 13.1481 11.7855C13.512 11.6347 13.8428 11.4138 14.1213 11.1352C14.3999 10.8566 14.6209 10.5259 14.7717 10.1619C14.9224 9.79795 15 9.40784 15 9.01387C15 8.61991 14.9224 8.2298 14.7717 7.86582C14.6209 7.50185 14.3999 7.17113 14.1213 6.89255C13.8428 6.61398 13.512 6.393 13.1481 6.24224C12.7841 6.09147 12.394 6.01387 12 6.01387C11.2044 6.01387 10.4413 6.32994 9.8787 6.89255C9.31609 7.45516 9.00002 8.21822 9.00002 9.01387C9.00002 9.80952 9.31609 10.5726 9.8787 11.1352C10.4413 11.6978 11.2044 12.0139 12 12.0139C11.2217 12.0139 10.5137 12.3104 9.98145 12.7956C9.29701 12.43 8.72465 11.8855 8.32545 11.2202C7.98556 10.6539 7.78113 10.0168 7.72813 9.35848C7.67512 8.70018 7.77497 8.03854 8.01988 7.42521C8.26479 6.81187 8.64814 6.26344 9.13999 5.82271C9.63185 5.38198 10.2189 5.06089 10.8553 4.8845C11.4918 4.7081 12.1604 4.68118 12.8089 4.80583C13.4575 4.93048 14.0684 5.20333 14.5941 5.60308C15.1198 6.00283 15.546 6.51867 15.8395 7.11032C16.1329 7.70198 16.2856 8.35345 16.2857 9.01387Z'
                  fill='white'
                />
              </svg>
              <span className='ml-3 text-white text-[16px] font-bold'>
                Support
              </span>
            </a>
          </li>
        </ul>
      </nav>

      {/* Log Out */}
      <div className='px-6 mb-4'>
        <button
          onClick={logout}
          className='flex items-center text-[#EF4444] w-full py-3 hover:text-red-600 transition-colors duration-200 ease-in-out'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='25'
            viewBox='0 0 24 25'
            fill='none'
          >
            <path
              d='M7.02301 5.94244C5.4122 7.01142 4.18841 8.57067 3.53281 10.3894C2.87722 12.208 2.82467 14.1895 3.38294 16.0404C3.94121 17.8913 5.08063 19.5132 6.63252 20.666C8.18441 21.8189 10.0663 22.4414 11.9995 22.4414C13.9328 22.4414 15.8146 21.8189 17.3665 20.666C18.9184 19.5132 20.0578 17.8913 20.6161 16.0404C21.1744 14.1895 21.1218 12.208 20.4662 10.3894C19.8106 8.57067 18.5868 7.01142 16.976 5.94244M12 2.44244V10.4424'
              stroke='#EF4444'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          <span className='ml-3'>Logout</span>
        </button>
      </div>

      {/* Version Info */}
      <div className='pl-6 pb-4 text-[rgba(255,255,255,0.50)] text-xs'>
        Version 1
      </div>
    </aside>
  )
}

export default Sidebar
